import Command from '../../actions/command';
import {call, fork, put, take} from 'redux-saga/effects';
import {Action} from 'redux-actions';
import Api from '../../../api';
import {SetEmployeeDefaultRatePayload} from '../../actions/dashboardCommand';

const onSetEmployeeDefaultRate = function*(data: SetEmployeeDefaultRatePayload) {
    try {
        yield call(Api.Command.Rate.setEmployeeDefaultRate, data.userId, data.hourlyRate);

        yield put(Command.Dashboard.fetchEmployeeRateList({}));

        yield put(Command.Notification.enqueueNotification({
            severity: 'success',
            message: 'Stundensatz wurde gespeichert.',
        }));
    } catch (e) {
        yield put(Command.Notification.enqueueNotification({
            severity: 'error',
            message: 'Stundensatz konnte nicht gespeichert werden.',
        }));
    }
};

export function* setEmployeeDefaultRateFlow() {
    while (true) {
        const action: Action<SetEmployeeDefaultRatePayload> =
            yield take(Command.Dashboard.setEmployeeDefaultRate.toString());
        yield fork(onSetEmployeeDefaultRate, action.payload);
    }
}
